import {createSelector} from 'reselect';

import {HostApplicationStoreType} from '../hostApplicationStoreType';

/**
 * returns data about router from host
 */
export const getRouter = (store: HostApplicationStoreType) => store.router;

/**
 * returns data about router from host
 */
export const getRouterInfo = (store: HostApplicationStoreType) => store.routerInfo;

/**
 *  getRouterSearchParams selector which return connected router location.search param
 * @returns {string} query params
 */
export const getRouterSearchParams = (store: HostApplicationStoreType): string => {
    return store ? store.router.location.search : '';
};

/**
 * Get type of the current page
 */
export const getPageType = createSelector(getRouter, router => router?.location?.state?.page ?? '');
